import {z} from 'zod';

/**
 * Message status enum for validation
 */
const MessageStatusEnum = z.enum(['PENDING', 'PROCESSING', 'SUCCESS', 'FAILED']);

/**
 * Schema that handles both array and comma-separated string formats for status
 */
const StatusSchema = z
  .union([
    MessageStatusEnum,
    z.array(MessageStatusEnum),
    z
      .string()
      .transform((val) => {
        // Handle comma-separated string from query parameters
        if (val.includes(',')) {
          return val.split(',').map((s) => s.trim());
        }
        // Single value
        return val;
      })
      .pipe(z.union([MessageStatusEnum, z.array(MessageStatusEnum)])),
  ])
  .optional();

/**
 * Schema for get all messages request query parameters
 */
export const getListMessagesRequestSchema = z.object({
  // Pagination parameters
  limit: z.coerce.number().int().positive().max(1000).optional(),
  offset: z.coerce.number().int().min(0).optional(),

  // Filter parameters
  userId: z.string().min(1).optional(),
  useCaseType: z.string().min(1).optional(),
  status: StatusSchema,

  // Date filters with from/to suffixes
  createdAtFrom: z.coerce.date().optional(),
  createdAtTo: z.coerce.date().optional(),
  updatedAtFrom: z.coerce.date().optional(),
  updatedAtTo: z.coerce.date().optional(),

  // Sorting parameters
  orderBy: z.enum(['createdAt', 'updatedAt']).optional(),
  order: z.enum(['asc', 'desc']).optional(),
});

export type GetListMessagesRequest = z.infer<typeof getListMessagesRequestSchema>;
